function disableParamsSection(paramsSection) {
  if(paramsSection.querySelectorAll('.dropdown-menu li.show').length === 0) {
    paramsSection.querySelector('.dropdown .btn').classList.add('disabled');
  }
}

document.querySelectorAll('.collapse-params').forEach(function (el) {
  const paramsSection = el.closest('.params-section');
  el.addEventListener('show.bs.collapse', function () {
    paramsSection.classList.add('has-shown');
  });
  el.addEventListener('shown.bs.collapse', function () {
    disableParamsSection(paramsSection);
  });
  disableParamsSection(paramsSection);
});